import { COUNTRIES } from '@/utils/countries';

const SORTED_PREFIXES = COUNTRIES.map((c) => c.dialCode)
  .filter(Boolean)
  .sort((a, b) => b.length - a.length);

export function splitPhone(phone: string): {
  prefix: string;
  number: string;
} {
  if (!phone) return { prefix: '', number: '' };
  const trimmed = phone.replace(/\s+/g, '');
  for (const code of SORTED_PREFIXES) {
    if (trimmed.startsWith(code)) {
      return { prefix: code, number: trimmed.slice(code.length) };
    }
  }
  return { prefix: '', number: trimmed };
}

export function joinPhone(prefix: string, number: string): string {
  const cleaned = number.replace(/\s+/g, '');
  if (!prefix && !cleaned) return '';
  return `${prefix}${cleaned}`.trim();
}
